
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IFileDeviceGeneration, IFileEncoderConfigurationAnalysisResource } from '@/types/resource.types';

@Component({
    name: 'MatchHistory',
})
export default class MatchHistory extends Vue {

    /* Props
    ============================================*/

    @Prop({ type: Array, required: true, default: () => [] })
    readonly devices!: IFileDeviceGeneration[];

    @Prop({ type: Object, required: false })
    readonly eca?: IFileEncoderConfigurationAnalysisResource;

    @Prop({ type: String, required: false })
    readonly classifiedBrand?: string;

    @Prop({ type: String, required: false })
    readonly classifiedModel?: string;

    @Prop({ type: String, required: false })
    readonly classifiedLastGeneration?: string;

    showAllDevices = false;

    get displayedDevices(): IFileDeviceGeneration[] {
        return this.showAllDevices ? this.devices : this.devices.slice(0, 10);
    }

    modelMatch(brand: string, model: string): Record<string, boolean> {
        if (!this.classifiedModel) return {};
        const match = this.classifiedModel === `${brand} ${model}`;
        return { 'model-match': match };
    }

    brandMatch(brand: string, model: string): Record<string, boolean> {
        if (!this.classifiedBrand) return {};
        const match = this.classifiedModel === `${brand} ${model}`;
        return { 'model-match': match, 'brand-match': this.classifiedBrand === brand && !match };
    }

    lastGenMatch(lastGeneration: string): Record<string, boolean> {
        if (!this.classifiedLastGeneration) return {};
        const match = this.classifiedLastGeneration === lastGeneration;
        return { 'model-match': match };
    }

    color(match?: boolean): string {
        return match ? 'success' : '';
    }

    icon(match?: boolean): string {
        return match ? 'mdi-check-circle' : '';
    }
}

